import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import AssessmentController from 'linced-app/controllers/group/assessments/assessment';

export default class _AssessmentController extends AssessmentController {
  @action
  setFilteredModules(value) {
    this.filteredModules = value;
  }

  @action
  setNewAsOnDate(value) {
    this.newAsOnDate = value;
  }

  @action
  setNewFromDate(value) {
    this.newFromDate = value;
  }

  @tracked
  filteredModules;

  @tracked
  newAsOnDate;

  @tracked
  newFromDate;
}
